import axios from './axiosInstances/privateAxiosInstance';
import { Sorting } from 'src/types/Sorting';
import SORT_ORDER from 'src/enums/sortOrder';
import { useEffect, useState } from 'react';

const API_URL_GETAPPPARAM = '/qs/account/user/getappparam';
const API_URL = '/qs/result/resultfilter';



type applicationPermissionResultPage = {
  value: any;
  name: string;
};

const getApplicationPermissionByNameResultPage = (name: string, permissions: Array<applicationPermissionResultPage>) => {
  const foundPermission = permissions.find((item: applicationPermissionResultPage) => item.name === name);
  return foundPermission ? foundPermission.value : 0;
};
export const useApplicationProductResultPageParams = (applicationId: string) => {
  const [permissionssss, setPermissionsss] = useState({
    isResultsView: 0,
  });

  useEffect(() => {
    axios &&
      axios
        .get(API_URL_GETAPPPARAM, {
          params: {
            appId: applicationId,
            appParams: 'max_days_for_results_view',
            appType:'int'
          },
        })
        .then((response: any) => {
          if (response && response.AppParams) {
            setPermissionsss({
              isResultsView: getApplicationPermissionByNameResultPage('max_days_for_results_view', response.AppParams),
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
  }, [applicationId]);
  return [permissionssss];
};



type TablePageListRequest = {
  pagesize?: number;
  offset: number;
  sortingcolumn?: string;
  sortingorder?: SORT_ORDER;
};

export const useGetResultList = (
  offset: number,
  size: number,
  sorting: Sorting<SORT_ORDER> | any,
  appId: string,
  search: any,
  createdStartDDD: any,
  createdEnd: any,
  finishedStart: any,
  finishedEnd: any,
  ownerNames:any,
  isPageType: any) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [resultList, setResultList] = useState<any>([]);
  const [sortingorders, setSortingorders] = useState("desc");
  const [productsError, setProductsError] = useState<boolean>(false);

  let  bAdminMode:boolean=false;
  let input = localStorage.getItem("bAdminMode");
  bAdminMode = (input === 'true');
  useEffect(() => {
    if(sorting !== "ascend"){
      setSortingorders("asc")
    }else{
      setSortingorders("desc")
    }
    
    let params = {
      offset,
      size,    
    } as TablePageListRequest;
    if (sorting) {
      params = {
        ...params,
       sortingorder: sortingorders !== undefined ? sortingorders : "desc",
      } as TablePageListRequest;
    }
    if (isPageType === undefined) {
      isPageType = 'All';
    }
    const data = {
      ...({
        SearchFilterResult: {
          jobType: isPageType,
          appId: appId !== null ? appId : "-1",
          createdStart: createdStartDDD !== undefined ? createdStartDDD : createdStartDDD,
          createdEnd: createdEnd,
          finishedStart: finishedStart,
          finishedEnd: finishedEnd,
          jobName: search,
          ownerName:ownerNames,
          allOrgAccounts:bAdminMode,
        }
      }),
    };
    if (params && createdStartDDD && sorting) {
      setLoading(false);
      axios && axios.post(API_URL, data, {
        params: params,
      })
        .then((response: any) => {
          if (response) {
            setResultList(response.resultList);
            setTotalRecords(response.totalRecords);
          }
          setLoading(true);
        })

        .catch(() => {
          setProductsError(true)
          setLoading(true);
        })
    } else {
      setResultList([]);
      setTotalRecords(0);
    }
  }, [offset,
    size,
    sorting,
    appId,
    createdStartDDD,
    createdEnd,
    finishedStart,
    finishedEnd,
    isPageType,
    ownerNames,
    search]);

  return [loading, totalRecords, resultList, productsError];
};


